import { ToggleInput, Tooltip } from '@demandlocal/components'
import React from 'react'

export default function EditUserPermissions() {
  return (
    <div className={'pt-6 pb-6 grid grid-cols-2'}>
      <div className={'max-w-sm'}>
        <div className={'flex flex-row gap-4 items-center'}>
          <ToggleInput name={'can_access_billing'} label={'Can access billing'} />
        </div>
      </div>
    </div>
  )
}
